import React from 'react';
import { colors } from '../../../styles/colors';

const BreakInformation = ({
  formData,
  handleInputChange,
  commonStyles
}) => {
  return (
    <div style={{
      backgroundColor: colors.surface,
      padding: '24px',
      borderRadius: '12px',
      marginBottom: '24px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <h3 style={{
        color: colors.text.primary,
        fontSize: '1.2rem',
        fontWeight: '700',
        marginBottom: '20px',
        paddingBottom: '10px',
        borderBottom: `2px solid ${colors.primary}`
      }}>Break Information (Optional)</h3>
      
      <p style={{
        color: colors.text.secondary,
        fontSize: '1rem',
        marginBottom: '20px',
        lineHeight: '1.5'
      }}>
        Breaks are only calculated based on your selected class and draw position. If you enter a break time and draw number, the calculator will apply it starting from your class and draw, not from any preceding classes. For example, if there's a 30-minute break between the Derby and Futurity, and you're running in the Open, that break will not be factored in. Only breaks within your class are considered. For break duration, enter time in hours (e.g., 0.25 for 15 minutes, 1.5 for 1 hour 30 minutes). 
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '20px'
      }}>
        <div>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Break Draw Number (optional)
          </label>
          <input
            type="number"
            name="breakDrawNumber"
            value={formData?.breakDrawNumber || ''}
            onChange={handleInputChange}
            min="1"
            placeholder="Enter break draw number"
            style={{...commonStyles.input}}
          />
        </div>

        <div>
          <label style={{
            display: 'block',
            marginBottom: '8px',
            color: colors.text.primary,
            fontSize: '1rem',
            fontWeight: '700'
          }}>
            Break Duration (hours) (optional)
          </label>
          <input
            type="number"
            name="breakDuration"
            value={formData?.breakDuration || ''}
            onChange={handleInputChange}
            min="0"
            step="0.01"
            placeholder="Enter break duration"
            style={{...commonStyles.input}}
          />
        </div>
      </div>
    </div>
  );
};

export default BreakInformation; 